// Maintenance
import MaintenanceView from 'views/Maintenance/MaintenanceView';
import MaintSignInView from 'views/Maintenance/MaintSignInView';
import MaintPrintingView from 'views/Maintenance/PrintingView';

// Set up
import SetUpView from 'views/Setup/SetUpView';
import SignInView from 'views/Setup/SignInView';
import SystemsCheckView from 'views/Setup/SystemCheckView';
import SetupPrintingView from 'views/Setup/PrintingView';

// Start up
import StartupView from 'views/Startup/StartupView';

// Ticketing
import AttractLoopView from 'views/Ticketing/AttractLoopView';
import EventsView from 'views/Ticketing/EventsView';
import GenresView from 'views/Ticketing/GenresView';
import StartPurchaseView from 'views/Ticketing/StartPurchaseView';
import TicketSelectionView from 'views/Ticketing/TicketSelectionView';
import TierSelectionView from 'views/Ticketing/TierSelectionView';
import CustomerView from 'views/Ticketing/CustomerView';
import PurchasePaymentView from 'views/Ticketing/PurchasePaymentView';
import OfflineView from 'views/Ticketing/OfflineView';
import PromoCodeApprovalView from 'views/Ticketing/PromoCodeApprovalView';
import PromoCodeSelectionView from 'views/Ticketing/PromoCodeSelectionView';
import PromoCodeEnterView from 'views/Ticketing/PromoCodeEnterView';
import MembershipLookupView from 'views/Ticketing/MembershipLookupView';
import InfoView from 'views/Ticketing/InfoView';
import SurveyView from 'views/Ticketing/SurveyView';
import SplashView from 'views/Ticketing/SplashView';
import CityPassScan from 'views/Ticketing/CityPassScan';
import MembershipLevelSelectionView from 'views/Ticketing/MembershipLevelSelectionView';
import MembershipDataCollectionView from 'views/Ticketing/MembershipDataCollectionView';
import DonationView from 'views/Ticketing/DonationView';
import UpsellSelectionView from 'views/Ticketing/UpsellSelectionView';
import LocationLookupView from 'views/Ticketing/LocationLookupView';
import SeatSelectionView from 'views/Ticketing/SeatSelectionView';
import SouvenirTicketView from 'views/Ticketing/SouvenirTicketView';

// Will Call (Also gets added to Ticketing routes)
import WillCallLookupView from 'views/Ticketing/WillCallLookupView';
import WillCallSelectionView from 'views/Ticketing/WillCallSelectionView';
import WillCallOrderListView from 'views/Ticketing/WillCallOrderListView';

// State Navigation
import UIAutomationView from 'views/UIAutomation';
import CartView from 'views/Ticketing/CartView';
import DeliveryView from 'views/Ticketing/DeliveryView';
import CompletionView from 'views/Ticketing/CompletionView';
import OrdersView from 'views/Ticketing/OrdersView';
import DeliverySelectionView from 'views/Ticketing/DeliverySelectionView';

export const routes = [
  {
    path: '/',
    component: SetUpView,
    name: 'Set Up',
    testID: 'setup-page'
  },
  {
    path: '/signin',
    component: SignInView,
    name: 'Sign In',
    testID: 'signin-page'
  },
  {
    path: '/ui-automation',
    component: UIAutomationView,
    name: 'UI Automation',
    testID: 'ui-automation-page'
  },
  {
    protected: true,
    path: '/startup',
    component: StartupView,
    name: 'Startup View',
    testID: 'startup-page'
  },
  {
    protected: true,
    path: '/systems',
    component: SystemsCheckView,
    name: 'Systems Check',
    testID: 'systems-check-page'
  },
  {
    protected: true,
    path: '/printing',
    component: SetupPrintingView,
    name: 'Printing',
    testID: 'printing-page'
  },
  {
    protected: true,
    path: '/maintenance/login',
    component: MaintSignInView,
    name: 'Maintenance Sign In',
    testID: 'maintenance-sign-in-page'
  },
  {
    protected: true,
    path: '/maintenance',
    component: MaintenanceView,
    name: 'Maintenance',
    testID: 'maintenance-page'
  },
  {
    protected: true,
    path: '/maintenance/printing',
    component: MaintPrintingView,
    name: 'Maintenance Printing',
    testID: 'maintenance-printing-page'
  },
  {
    ticketing: true,
    protected: true,
    disableTimer: true,
    path: '/ticketing/attract',
    component: AttractLoopView,
    name: 'Attract Loop',
    testID: 'attract-loop-page'
  },
  {
    protected: true,
    ticketing: true,
    path: '/ticketing/splash',
    component: SplashView,
    name: 'Splash View',
    testID: 'splash-view'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/start-purchase',
    component: StartPurchaseView,
    name: 'Start Purchase',
    testID: 'start-purchase-page'
  },
  {
    protected: true,
    ticketing: true,
    path: '/ticketing/info',
    component: InfoView,
    name: 'Info View',
    testID: 'info-view'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/membership-lookup',
    component: MembershipLookupView,
    name: 'Membership Lookup View',
    testID: 'membership-lookup'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/location-lookup',
    component: LocationLookupView,
    name: 'Location Lookup View',
    testID: 'location-lookup'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/citypass',
    component: CityPassScan,
    name: 'CityPASS Scan View',
    testID: 'citypass-scan'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/donation',
    component: DonationView,
    name: 'Donation',
    testID: 'donation-page'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/genres',
    component: GenresView,
    name: 'Genres',
    testID: 'genres-page'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/events',
    component: EventsView,
    name: 'Events',
    testID: 'events-page'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/tiers',
    component: TierSelectionView,
    name: 'Ticket Tier',
    testID: 'tier-page'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/selection',
    component: TicketSelectionView,
    name: 'Ticket Selection',
    testID: 'ticket-selection-page'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/membership-level-selection',
    component: MembershipLevelSelectionView,
    name: 'Membership Level Selection',
    testID: 'membership-level-selection-page'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/membership-data-collection',
    component: MembershipDataCollectionView,
    name: 'Membership Data Collection',
    testID: 'membership-data-collection-page'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/upsell-selection',
    component: UpsellSelectionView,
    name: 'Upsell Selection',
    testID: 'upsell-selection-page'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/seat-selection',
    component: SeatSelectionView,
    name: 'Seat Selection',
    testID: 'seat-selection-page'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/cart',
    component: CartView,
    name: 'Cart',
    testID: 'cart-page'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/cart/customer',
    component: CustomerView,
    name: 'Customer Lookup',
    testID: 'customer-lookup-page'
  },
  {
    protected: true,
    ticketing: true,
    path: '/ticketing/cart/survey',
    component: SurveyView,
    name: 'Survey View',
    testID: 'survey-view'
  },
  {
    ticketing: true,
    protected: true,
    disableTimer: true,
    path: '/ticketing/purchase/payment',
    component: PurchasePaymentView,
    name: 'Purchase Payment',
    testID: 'purchase-page'
  },
  {
    ticketing: true,
    protected: true,
    disableTimer: false,
    path: '/ticketing/cart/delivery-selection',
    component: DeliverySelectionView,
    name: 'Delivery method selection',
    testID: 'delivery-selection'
  },
  {
    ticketing: true,
    protected: true,
    disableTimer: true,
    path: '/:path/delivery',
    component: DeliveryView,
    name: 'Purchase Printing',
    testID: 'printing-page'
  },
  {
    ticketing: true,
    protected: true,
    disableTimer: true,
    path: '/:path/completion',
    component: CompletionView,
    name: 'Purchase Complete',
    testID: 'purchase-complete-page'
  },
  {
    ticketing: true,
    protected: true,
    disableTimer: true,
    path: '/ticketing/offline',
    component: OfflineView,
    name: 'Offline',
    testID: 'offline-page'
  },
  {
    ticketing: true,
    protected: true,
    disableTimer: false,
    path: '/willcall/lookup',
    component: WillCallLookupView,
    name: 'Will Call Lookup',
    testID: 'will-call-lookup'
  },
  {
    ticketing: true,
    protected: true,
    disableTimer: false,
    path: '/willcall/orders',
    component: OrdersView,
    name: 'Will Call Orders',
    testID: 'will-call-orders'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/promo-code/approval',
    component: PromoCodeApprovalView,
    name: 'Promo Code Approval View',
    testID: 'promo-code-approval'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/promo-code/selection',
    component: PromoCodeSelectionView,
    name: 'Promo Code Selection View',
    testID: 'promo-code-selection'
  },
  {
    ticketing: true,
    protected: true,
    disableTimer: false,
    path: '/ticketing/:path/:style',
    component: PromoCodeEnterView,
    name: 'Promo Code Enter View',
    testID: 'promo-code-enter'
  },
  {
    ticketing: true,
    protected: true,
    path: '/ticketing/souvenir-ticket',
    component: SouvenirTicketView,
    name: 'Souvenir Ticket View',
    testID: 'souvenir-ticket-page'
  },
  {
    ticketing: true,
    protected: true,
    path: '/willcall/selection',
    component: WillCallSelectionView,
    name: 'Will Call Selection',
    testID: 'will-call-selection'
  },
  {
    ticketing: true,
    protected: true,
    path: '/willcall/orders-list',
    component: WillCallOrderListView,
    name: 'Will Call Orders List',
    testID: 'will-call-orders-list'
  }
];
